import { addMonths, getDate, startOfMonth } from 'date-fns'

type ResetDateType = 'day-of-month' | 'end-of-month'

const COUNTRY_RESET_RULES: Record<string, ResetDateType> = {
  es: 'day-of-month',
  pt: 'end-of-month',
}

const DEFAULT_RULE: ResetDateType = 'day-of-month'

export const calculateResetDate = (currentDate: Date, country: string): Date => {
  const rule = COUNTRY_RESET_RULES[country] || DEFAULT_RULE
  const currentDay = getDate(currentDate)

  if (rule === 'day-of-month') {
    const targetMonth = currentDay >= 20 ? addMonths(currentDate, 1) : currentDate
    return new Date(targetMonth.getFullYear(), targetMonth.getMonth(), 20)
  }

  if (rule === 'end-of-month') {
    return startOfMonth(addMonths(currentDate, 1))
  }

  return new Date(currentDate.getFullYear(), currentDate.getMonth(), 20)
}
